import { Check } from 'lucide-react';
import type { ChangeEvent } from 'react';

import { SelectionBurst, useSelectionBurst } from '@/shared/ui/SelectionBurst';
import { cn } from '@/shared/utils/cn';

import { COURSE_CARD_CORNER_BASE } from '../lib/course-card-corner-control';

interface CourseCardSelectionControlProps {
  checked: boolean;
  label: string;
  name: string;
  value: string;
  className?: string;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
}

export function CourseCardSelectionControl({
  checked,
  label,
  name,
  value,
  className,
  onChange,
}: CourseCardSelectionControlProps) {
  const { burstKey, variant, triggerBurst } = useSelectionBurst();

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    triggerBurst(event.currentTarget.checked ? 'cyan' : 'muted');
    onChange(event);
  };

  return (
    <label
      className={cn(
        COURSE_CARD_CORNER_BASE,
        'has-[:focus-visible]:ring-adipa-secondary has-[:focus-visible]:ring-2 has-[:focus-visible]:ring-offset-2',
        checked
          ? 'border-adipa-secondary bg-adipa-secondary text-adipa-primary-foreground'
          : 'border-white/80 bg-white/95 text-navy/35 hover:text-adipa-secondary',
        className,
      )}
    >
      <span className="sr-only">{label}</span>
      <input
        checked={checked}
        className="peer sr-only"
        name={name}
        type="checkbox"
        value={value}
        onChange={handleChange}
        onClick={(event) => event.stopPropagation()}
      />
      <SelectionBurst burstKey={burstKey} variant={variant} className="z-20" />
      <Check aria-hidden="true" className="relative z-10 h-3.5 w-3.5" strokeWidth={2.8} />
    </label>
  );
}
